import { extendTheme } from "@chakra-ui/react";
import colors from "styles/colors";
import textStyles from "styles/typographies";
import Button from "styles/components/button";

const breakpoints = {
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "90em",
};

const overrides = (locale) => ({
  config: {
    initialColorMode: "dark",
    useSystemColorMode: false,
  },
  components: {
    Button,
    Switch: {
      baseStyle: {
        thumb: {
          marginTop: "-6px",
          marginLeft: "-3px",
          boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.5)",
        },
        track: {
          marginTop: "10px",
          height: "6px",
          width: "26px",
          padding: "0px",
          backgroundColor: "gray.300",
          _focus: {
            boxShadow: "0 0 0",
          },
        },
      },
      variants: {
        neutral: {
          track: {
            _checked: {
              backgroundColor: "gray.300",
            },
          },
        },
        branded: {
          track: {
            _checked: {
              backgroundColor: "primary",
            },
          },
        },
      },
      defaultProps: {
        variant: "neutral",
      },
    },
    Slider: {
      baseStyle: {
        thumb: {
          boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.5)",
          _focus: { boxShadow: "0 0 2px 2px #05fc7b99" },
        },
        track: {
          backgroundColor: "gray.300",
          _focus: {
            boxShadow: "0 0 0",
          },
          _checked: {
            backgroundColor: "gray.300",
          },
        },
      },
    },
    Checkbox: {
      baseStyle: {
        control: {
          backgroundColor: "rgba(216, 216, 216, 0.1)",
          borderRadius: "0px",
          border: "1px",
          _focus: { boxShadow: "0 0 2px 2px #0fb96099" },
        },
      },
    },
    Modal: {
      baseStyle: {
        closeButton: {
          _focus: { boxShadow: "none" },
        },
        dialog: {
          borderRadius: "md",
          bg: "gray.100",
          color: "black.900",
        },
      },
    },
  },
  breakpoints,
  sizes: {
    md: "800px",
    lg: "1024px",
    xl: "1500px",
  },
  space: {
    xxs: "4px",
    xs: "8px",
    sm: "16px",
    md: "24px",
    lg: "32px",
    xl: "48px",
    xxl: "64px",
    xxxl: "80px",
  },
  shadows: {
    outline: "0 0 0 3px #0fb96099",
  },
  letterSpacings: {
    enormous: "0.25em",
  },
  fontSizes: {
    xxs: "10px",
  },
  fonts:
    locale === "ru"
      ? { body: "Roboto", heading: "Roboto" }
      : { body: "Verbatim", heading: "Verbatim-Wide" },
  colors,
  textStyles,
});

const theme = (locale) => extendTheme(overrides(locale));

export default theme;
